import { z } from 'zod'

export const addCoverCancelFiltersSchema = z.object({
  teacherId: z.string().optional(),
  dateAfter: z.string().optional(),
  dateBefore: z.string().optional()
})
